export const STATIC_FILES_DIRECTORY = 'public';
export const UI_CONFIG_DIRECTORY = 'ui-config';
export const UI_CONFIG_PATH = `${STATIC_FILES_DIRECTORY}/${UI_CONFIG_DIRECTORY}`;
